import type {WorkMetadata} from 'services/metadata/types';

export const mapWorkMetadataToProductOwnerIds = (
  workMetadata: WorkMetadata,
): string[] => {
  return [
    ...new Set(
      (workMetadata?.manifestations ?? [])
        .map(m => m?.productOwners?.map(p => p?.id))
        .flat(1)
        .filter(a => a) as string[],
    ),
  ];
};
